export default __webpack_public_path__ + "static/media/ls3_g05.51355afb.png";